import React from 'react';
import '../styles/Icon.scss';
const Icon=({type})=>{
    return (
        <img src={type} className="icons" alt="icon"/>
    )
}
export default Icon;